export const createEmptyCompanyInfo = () => ({
  useCustom: false,
  companyName: '',
  enrolmentNo: '',
  address: '',
  phone: '',
  website: '',
});

export const buildCompanyFromSettings = (settings = {}) => {
  const addressParts = [
    settings.address_line1,
    settings.address_line2,
    settings.city,
    settings.county,
    settings.postcode,
  ].filter(Boolean);

  return {
    useCustom: false,
    companyName: settings.company_name || '',
    enrolmentNo: settings.enrolment_no || '',
    address: addressParts.join(', '),
    phone: settings.phone || '',
    website: settings.website || '',
  };
};

export const createEmptySectionDeclaration = (options = {}) => ({
  bs7671Departures: '',
  permittedExceptions: options.includeExceptions ? '' : undefined,
  riskAssessmentStatus: options.includeRiskAssessment ? '' : undefined,
  engineer: { id: '', label: '', type: '', value: '' },
  engineerDate: '',
  company: createEmptyCompanyInfo(),
  secondPair: null,
});

export const DEFAULT_SECTION_DECLARATIONS = {
  design: createEmptySectionDeclaration({ includeExceptions: true, includeRiskAssessment: true }),
  construction: createEmptySectionDeclaration(),
  inspection: createEmptySectionDeclaration(),
};

export const normalizeRiskAssessmentStatus = (value) => {
  if (value === true || value === 'yes') return 'yes';
  if (value === false || value === 'na') return 'na';
  return '';
};

export const mergeOptionsWithLegacy = (options, signatory) => {
  const base = Array.isArray(options) ? [...options] : [];
  if (!signatory || !signatory.value) return base;

  const alreadyPresent = base.some((opt) => opt.value === signatory.value);
  if (alreadyPresent) return base;

  const baseLabel = signatory.label || signatory.value.replace(/^legacy:/, '') || 'Legacy selection';
  base.push({
    value: signatory.value,
    label: baseLabel.endsWith(' (legacy)') ? baseLabel : `${baseLabel} (legacy)`,
    type: signatory.type || 'legacy',
    disabled: true,
  });
  return base;
};

export const resolveCompanyDisplay = (company, tenantCompanyInfo) => {
  if (company?.useCustom) {
    return {
      companyName: company.companyName || '',
      enrolmentNo: company.enrolmentNo || '',
      address: company.address || '',
      phone: company.phone || '',
      website: company.website || '',
    };
  }
  return tenantCompanyInfo || createEmptyCompanyInfo();
};
